module.exports = __webpack_public_path__ + "static/antivol4-d9b5c8bd4674a94edd7abd93fb97d8ff.jpg";